<template>
  <div class="oct-account-form oct-grid">
    <div class="oct-grid__row">
      <div class="oct-grid__col oct-grid__col--6">
        <oct-article-header
          :title="$_octUser_id ? 'ACCOUNT\nSETTINGS' : 'CREATE \nYOUR \nACCOUNT.'"
          :text="$_octUser_id ? 'アカウント設定' : 'アカウントを作成'"
        />
      </div>

      <div class="oct-grid__col oct-grid__col--6">
        <oct-form class="oct-account-form__form" v-if="process !== 'created'">
          <!-- @event 'change' -->
          <oct-form-group
            label="メールアドレス"
          >
            <oct-text-field
              placeholder="youremail@marph.com"
              helperTextInvalid="有効なメールアドレスを入力してください"
              type="email"
              required
              disabled
              v-model="$_octUser_email"
              @change="$emit('change', $event)"
              ref="octUser_email"
            />

            <template #caption>※メールアドレス変更機能は後日実装予定</template>
          </oct-form-group>

          <!-- @event 'change' -->
          <oct-form-group label="氏名">
            <oct-text-field
              helperTextInvalid="氏名を入力してください"
              :disabled="type !== 'user'"
              required
              v-model="$_octUser_name"
              @change="$emit('change', $event)"
              ref="octUser_name"
            />
          </oct-form-group>

          <!-- @event 'change' -->
          <oct-form-group label="ユーザー名 ※半角英数小文字ハイフン、アンダーバーのみ">
            <oct-text-field
              placeholder="marph"
              required
              :disabled="type !== 'user'"
              helperTextInvalid="そのユーザー名は他の人に使われています"
              :validator="getDisplayNameAvailability"
              v-model="$_octUser_displayName"
              @change="invalid === true;$emit('change', $event)"
              ref="octUser_displayName"
            />
          </oct-form-group>

          <oct-form-row class="oct-account-form__row" v-if="id && /^auth0/.test(id)">
            <oct-form-col dense :cols="0">
              <p class="oct-account-form__body-text">
                氏名及びユーザー名の変更をご希望の場合は<a href="https://marph.tayori.com/f/edit-profile" target="_blank">こちら</a>までお問い合わせください。
              </p>
            </oct-form-col>
          </oct-form-row>

          <oct-form-row class="oct-account-form__row" v-if="id && /^auth0/.test(id)">
            <oct-form-col dense :cols="0">
              <p class="oct-account-form__body-text">
                <a href="/account/password-reminder/?reset">パスワードを変更する</a>
              </p>
            </oct-form-col>
          </oct-form-row>

          <oct-form-row class="oct-account-form__row">
            <oct-form-col dense>
              <oct-checkbox
                required
                v-model="$_octUser_subscription"
                @change="confirm"
              />
            </oct-form-col>

            <oct-form-col dense :cols="0">
              <p class="oct-account-form__body-text">フォローしているアーティストやギャラリーからの<br>最新情報を受け取る</p>
            </oct-form-col>
          </oct-form-row>

          <oct-form-row class="oct-account-form__row" v-if="!id">
            <oct-form-col dense>
              <oct-checkbox
                required
                ref="octUser_agreement"
                @change="confirm"
              />
            </oct-form-col>

            <oct-form-col dense :cols="0">
              <p class="oct-account-form__body-text"><a href="https://marph.com/terms-of-use" target="_blank">利用規約</a>と<a href="https://marph.com/privacy-policy" target="_blank">プライバシーポリシー</a>に同意し、MARPHからのメールを受信することに同意します。</p>
            </oct-form-col>
          </oct-form-row>
          
          <template #primaryActions>
            <oct-button
              :href="type === 'artist' || type === 'gallery' ? '/account/dashboard' : '/'"
              size="large"
              v-if="$_octUser_id"
            >
              Cancel
            </oct-button>

            <oct-button
              :type="process === 'processing' ? 'processing' : 'primary'"
              size="large"
              :disabled="invalid"
              @click.native="submit"
            >
              {{ $_octUser_id ? 'Save' : 'Create Account' }}
            </oct-button>
          </template>
        </oct-form>

        <oct-form class="oct-account-form__form" v-else>
          <div class="oct-account-form__text">
            <p class="oct-account-form__primary-text">アカウントの作成が完了しました。</p>
          </div>
          
          <template #primaryActions>
            <oct-button
              href="/"
              type="primary"
              size="large"
            >
              はじめる
            </oct-button>
          </template>
        </oct-form>
      </div>
    </div>
  </div>
</template>

<script>
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js'
import OctUser from '@/components/user/OctUser.js'
import OctPrototypeForm from '@/components/prototype-form/OctPrototypeForm.js'
import OctArticleHeader from '@/components/article-header/OctArticleHeader.vue';

export default {
  mixins: [OctUser, OctPrototypeForm],
  name: 'OctAccountForm',
  components: {
    OctArticleHeader
  },
  props: {
    /**
     * Process state [new | initialized | processing | created ]
    */
   process: {
     type: String,
     default: 'new'
   },
  },
  data () {
    return {
      invalid: true
    }
  },
  computed: {
  },
  methods: {
    /** Check the availability of display name */
    async getDisplayNameAvailability (val) {
      let available = true

      try {
        // Check the display name availability
        const response = await OctApiAdaptor.getUsers({display_name: val})

        // Available if no user is hit or hit user is myself
        available = !response.items.length || response.items[0].id === this.id
      } catch (thrown) {
        alert('システムエラーが発生しました')
        console.log(thrown)
      }

      return available
    }
  },
  mounted () {
    // Add validation targets
    this.$data.$_octPrototypeForm_validationTargets = [
      this.$refs['octUser_name'],
      this.$refs['octUser_email'],
      this.$refs['octUser_displayName'],
      this.$refs['octUser_agreement']
    ]
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-account-form {
  margin-top:  oct-rem(46);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-top:  oct-rem(72);
}
}

.oct-account-form__form {
@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(384);
}
}

.oct-account-form__row {
  flex-wrap: nowrap;
  margin-bottom: oct-rem(8);

  .oct-form__col {
    align-items: center;
    min-height: 0;
  }
}

.oct-account-form__text {
  margin: 0 0 oct-rem(48);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 0 oct-rem(74);
}
}

.oct-account-form__primary-text {
  font-size: oct-rem(15);
  font-weight: normal;
  line-height: (24/15);
  margin: (-6em/15) 0;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(17);
  line-height: (30/17);
  margin: (-8em/17) 0;
}
}

.oct-account-form__body-text {
  font-size: oct-rem(13);
  font-weight: normal;
  line-height: (18/13);
  margin: (-4em/13) 0;

  a {
    color: inherit;
  }

  br {
    display: none;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  br {
    display: initial;
  }
}
}
</style>
